<template>
  <div
    v-if="loading"
    class="d-flex justify-center align-center"
    style="height: 100vh;"
  >
    <v-progress-circular
      indeterminate
      color="#2661FF"
      size="80"
    ></v-progress-circular>
  </div>
  <div v-else>
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-lg pa-2 custom_card" flat>
          <v-card-title class="text-color">
            <h2
              class="text-h6 grey--text text--darken-3 font-weight-medium mb-2 ml-6 text-color"
              style="font-size: 20px !important;"
            >
              {{ $t('signup.notification.title') }}
            </h2>
          </v-card-title>
          <v-card-text class="px-10">
            <v-row>
              <v-col cols="12" class="d-flex justify-start align-center">
                <p class="text-color text-body-2">
                  {{ $t('signup.notification.description') }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-form v-model="valid" ref="notification-sender" lazy-validation>
              <v-row
                no-gutters
                class="d-flex justify-center align-center"
                style="gap: 32px"
              >
                <v-col cols="12" md="5">
                  <v-select
                    v-model="form.sender"
                    :items="senders"
                    :label="$t('signup.notification.sender')"
                    :rules="rules.sender"
                    item-text="email"
                    item-value="id"
                    class="rounded-lg font-weight-regular"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="form.sendgrid_template_id"
                    :items="senders"
                    :label="$t('signup.notification.sendgrid_template')"
                    :rules="rules.sendgrid_template"
                    class="rounded-lg font-weight-regular"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end mx-2">
            <v-btn
              color="#2661FF"
              class="rounded-lg white--text"
              @click="saveNotificationSettings"
              :disabled="!valid"
              :loading="loading"
            >
              {{ $t('actions.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'NotificationManager',
  data() {
    return {
      valid: false,
      loading: false,
      form: {
        sender: null,
        sendgrid_template_id: null
      },
      rules: {
        sender: [
          v =>
            !!v ||
            this.$t('messages.validation_error.required', {
              field: this.$t('signup.notification.sender')
            })
        ],
        sendgrid_template: [
          v =>
            !!v ||
            this.$t('messages.validation_error.required', {
              field: this.$t('signup.notification.sendgrid_template')
            })
        ]
      }
    }
  },
  async created() {
    this.loading = true
    await this.fetchNotificationSenderSettings()
    await this.fetchNotificationAvailableSenders()

    // Initialize form with existing settings
    if (Object.keys(this.notificationSettings).length) {
      this.form.sender = Number(this.notificationSettings.userId)
      this.form.sendgrid_template_id = this.notificationSettings.sendgridTemplateId
    }

    this.loading = false
  },
  computed: {
    ...mapState({
      notificationSettings: state => state.signup.notificationSenderSettings,
      senders: state => state.signup.notificationAvailableSenders
    })
  },
  methods: {
    ...mapActions({
      saveNotificationSenderSettings: 'signup/saveNotificationSenderSettings',
      fetchNotificationSenderSettings: 'signup/fetchNotificationSenderSettings',
      fetchNotificationAvailableSenders:
        'signup/fetchNotificationAvailableSenders'
    }),
    async saveNotificationSettings() {
      const form = this.$refs['notification-sender']

      const formValidation = form.validate()
      if (!formValidation) return

      this.loading = true

      const payload = {
        senderId: this.form.sender,
        sendgridTemplateId: this.form.sendgrid_template_id
      }

      await this.saveNotificationSenderSettings(payload)
      await this.fetchNotificationAvailableSenders()

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}

.text-color {
  color: #344054 !important;
}

.header-color {
  color: #2661ff !important;
}
</style>
